import { AdminTitle } from "../../store/reducers/site";

const DashboardMain = () => {

    return(
        <>
            <AdminTitle title="Dhashboard"/>
            Dashboard main
        </>
    )
}

export default DashboardMain;